// extracted by mini-css-extract-plugin
var _1 = "bpl__header-profile__dZ53z";
var _2 = "bpl__header-profile__avatar__cpK5v";
var _3 = "bpl__header-profile__label__A5DB3";
export { _1 as "header-profile", _2 as "header-profile__avatar", _3 as "header-profile__label" }
